import axiosInstance from "@/api/axiosInstance";
import { CoachAttemptDetail } from "@/modules/growthStages/features/Diagnostics/types/diagnostic";

export const completeAttempt = async (
  attemptId: number,
): Promise<CoachAttemptDetail> => {
  const response = await axiosInstance.post<CoachAttemptDetail>(
    `/api/private/attempts/${attemptId}/complete`,
  );
  return response.data;
};
